import React from 'react'
import { cn } from '../../../utils/cn'
import { RiRecordCircleFill } from 'react-icons/ri'
import { Button } from 'antd'
import { motion } from 'framer-motion'
import { FaSquareCheck } from 'react-icons/fa6'
import { BsPinAngleFill } from 'react-icons/bs'

function ProductDetail({ producto }) {

    console.log(producto[0].description)

    return (
        <div className='w-full container mx-auto py-10 p-5 md:px-0 h-min flex items-center'>
            <div className='w-full flex md:flex-row flex-col  gap-20 mt-5'>
                {
                    producto?.map((product, index) => (
                        <motion.div
                            initial={{ opacity: 0, y: 100 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}

                            className={cn('w-full border-4  shadow-xl p-10 rounded-xl justify-between flex flex-col items-center max-w-[400px] min-h-[400px] gap-5', {
                                'border-t-yellow-500': product.category,
                                'border-t-blue-500': !product.category
                            })}>
                                 <img src={product.img} alt={product.name} className='w-20 h-20 object-cover' />
                            <h3 className='text-3xl font-normal text-center'>
                                {product.name}
                            </h3>
                            <p className='text-base text-gray-500 text-center'>
                                {product.subtitle}
                            </p>
                            <ul className='font-semibold text-sm self-start'>
                                {
                                    product.items.map((feature, index) => (
                                        <li key={index} className='flex gap-2'>
                                            <BsPinAngleFill className='text-red-500' size={20} /> 
                                            {feature}
                                        </li>
                                    ))
                                }
                            </ul>
                            <div className='border-2 border-blue-500 p-5 w-[60%] flex flex-col gap-3 items-center'>
                                <RiRecordCircleFill className='text-blue-500 text-4xl' />
                                <p className='font-bold text-sm'>
                                    Mes
                                </p>
                                <p className='text-2xl font-bold'>
                                    {product.price} UF
                                </p>
                            </div>
                            <p className='text-gray-500'>
                                *Valor no incluye IVA<br />
                                Planes son a 12 meses
                            </p>
                            <Button
                                onClick={() => {
                                    document.getElementById('form').scrollIntoView({ behavior: 'smooth' })

                                }}
                                className='bg-red-700 text-2xl py-7 text-white w-full rounded-full'>
                                Contáctanos
                            </Button>
                        </motion.div>
                    ))
                }
                <div className='flex flex-col gap-5 max-w-[500px]'>
                    <div>
                        <h3 className='font-bold text-3xl'>
                            {producto[0].name}
                        </h3>
                        <p className='italic'>
                            "{producto[0].description.subtitle}"
                        </p>
                    </div>
                    <p className='text-lg'>
                        {producto[0].description.text}
                    </p>
                    <ul>
                        {
                            producto[0].description.items.map((feature, index) => (
                                <li key={index} className='flex gap-2 font-bold '>
                                    <FaSquareCheck size={25} className='text-green-500' />
                                    {feature}
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default ProductDetail